import { createApp } from "vue";
import App from "./App.vue";
import "@/common/adobetypekit.js";
import router from "./router.js";
import "vuetify/dist/vuetify.min.css";
import { createVuetify } from "vuetify";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";

const app = createApp(App);

// Routerの設定
app.use(router);

// Vuetifyの設定
const vuetify = createVuetify({
  components,
  directives,
});

app.use(components);
app.use(directives);
app.use(vuetify);
app.mount("#app");
// import { createApp } from "vue";
// import App from "./App.vue";
// import "@/common/adobetypekit.js";
// import router from "./router.js";
// import "vuetify/styles";
// import { createVuetify } from "vuetify";
// import * as components from "vuetify/components";
// import * as directives from "vuetify/directives";

// const app = createApp(App);

// // Routerの設定
// app.use(router);

// // Vuetifyの設定
// const vuetify = createVuetify({
//   components,
//   directives,
// });

// app.use(vuetify);
// app.mount("#app");

//createApp(App)は二回使うと表示が死ぬので忘れないように

//以下はVue2の書き方
// import Vue from "vue";
// import App from "./App.vue";
// import vuetify from "./plugins/vuetify";
// //import router from '../router'
// import "@/common/adobetypekit.js";
// //import "./plugins/vue-youtube.js";

// app.mount("#app");

// Vue.config.productionTip = false;

// new Vue({
//   //  router,
//   vuetify,
//   render: (h) => h(App),
// }).$mount("#app");
